import {
  AppCode,
  AppCodeUse,
  Club,
  Collection,
  CollectionFollower,
  CollectionItem,
  Experience,
  ExperienceGuidePage,
  ExperienceMessage,
  ExperiencePackage,
  Event,
  Favorite,
  Gear,
  LiveLog,
  Photo,
  PointOfInterest,
  PrivacyCode,
  RideReport,
  Route,
  RouteSetOverview,
  Subscription,
  SegmentMatch,
  TmsJob,
  TmsKey,
  TmsValue,
  Trip,
  User
} from 'data/records'

// These are the records that will be automatically deserialized and stored
// under state.apiv3 when seen All known apiv3 record types should be specified
// here.
export const records = [
  AppCode,
  AppCodeUse,
  Club,
  Collection,
  CollectionFollower,
  CollectionItem,
  Experience,
  ExperienceGuidePage,
  ExperienceMessage,
  ExperiencePackage,
  Event,
  Favorite,
  Gear,
  LiveLog,
  Photo,
  PointOfInterest,
  PrivacyCode,
  RideReport,
  Route,
  RouteSetOverview,
  Subscription,
  SegmentMatch,
  TmsJob,
  TmsKey,
  TmsValue,
  Trip,
  User
]
